'use strict';
import module from './me.module';

module.controller('MeController', [
  'AppService',
  'CurrentUserService',
  function (AppService, CurrentUserService) {
    this.currentUser = CurrentUserService.currentUser;
    this.mode = 'gift-list';
    this.modeTitle = 'Gift ideas for me';
    this.modeListOpen = false;

    this.changeMode = function (mode) {
      if (mode === 'gift-list') {
        this.mode = 'gift-list';
        this.modeTitle = 'Gift ideas for me';
      } else if (mode === 'bought-list') {
        this.mode = 'bought-list';
        this.modeTitle = "Gifts I've bought";
      } else if (mode === 'suggested-list') {
        this.mode = 'suggested-list';
        this.modeTitle = "Gifts I've suggested";
      }
      this.modeListOpen = false;
    };

    this.toggleModeOpen = function () {
      this.modeListOpen = !this.modeListOpen;
    };

    AppService.pageTitle = 'Me';
  },
]);
